import { supabase } from "@/integrations/supabase/client";

export type AuditAction =
  | "approve_partner_request"
  | "reject_partner_request"
  | "approve_job"
  | "reject_job"
  | "pause_job"
  | "publish_job"
  | "approve_contact"
  | "reject_contact"
  | "view_profile"
  | "create_shortlist"
  | "add_to_shortlist"
  | "remove_from_shortlist"
  | "request_contact"
  | "export_report"
  | "update_application_status";

interface AuditLogParams {
  orgId: string;
  action: AuditAction;
  entityType?: string;
  entityId?: string;
  metadata?: Record<string, unknown>;
}

/**
 * Insert an audit log entry. Silently fails (non-blocking).
 */
export async function logAudit({ orgId, action, entityType, entityId, metadata }: AuditLogParams) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    await supabase.from("partner_audit_logs").insert([{
      org_id: orgId,
      actor_user_id: user?.id ?? null,
      action,
      entity_type: entityType ?? null,
      entity_id: entityId ?? null,
      metadata: (metadata as any) ?? null,
    }]);
  } catch {
    // Non-blocking — don't disrupt the user flow
  }
}
